import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Portfolio from "@meetyoo/components/src/components/Portfolio";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ErrorModal from "@meetyoo/components/src/components/Modal/ErrorModal";
import { moveEVN, restEVNError } from "../../../actions/billing";
import { useDefaultPasscodeStyles } from "../../../constants/passCodeUtils";

export const BillingEventCapsComponent = ({ requestFn, stateErrorMessage, resetFn }) => {
  const pc = useDefaultPasscodeStyles();

  const [openError, setOpenError] = useState(false);
  /** String state: avoids number/string mixing on input and keeps TextField controlled. */
  const [fromDocumentNo, setFromDocumentNo] = useState("");
  const [toDocumentNo, setToDocumentNo] = useState("");
  const [makeRequest, setMakeRequest] = useState(false);
  useEffect(() => {
    const request = async () => {
      if (makeRequest) {
        await requestFn(fromDocumentNo, toDocumentNo);
        setMakeRequest(false);
      }
    };
    request();
  }, [fromDocumentNo, toDocumentNo, setMakeRequest, requestFn, makeRequest]);

  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    if (stateErrorMessage !== errorMessage && stateErrorMessage === "400 - Bad Request") {
      setOpenError(true);
      setErrorMessage("Contract Number seems not existing");
    } else if (stateErrorMessage !== errorMessage) {
      setOpenError(true);
      setErrorMessage(stateErrorMessage);
    }
  }, [stateErrorMessage, errorMessage, setErrorMessage, setOpenError]);

  const handleCloseErrorModal = () => {
    setOpenError(false);
    setErrorMessage("");
    resetFn();
  };

  const invalidInputSx = {
    "& input:invalid": {
      background: "#F08080",
    },
  };

  return [
    <Portfolio
      title="EVN-Umhängen"
      key="container-contract_reset"
      component={
        <Box sx={{ textAlign: "center", display: "inline" }}>
          <div>
            <Box sx={{ display: "inline-flex" }}>
              <TextField
                sx={[pc.textField, invalidInputSx]}
                label="From old Document Number"
                value={fromDocumentNo}
                onChange={event => setFromDocumentNo(event.target.value)}
                margin="normal"
                slotProps={{
                  htmlInput: {
                    /* Hyphen first: valid in HTML + JS `v`-flag regex (see browser validation). */
                    pattern: "[-A-Z0-9]*",
                  },
                }}
              />
              <TextField
                sx={[pc.textField, invalidInputSx]}
                label="To new Document Number"
                value={toDocumentNo}
                onChange={event => setToDocumentNo(event.target.value)}
                margin="normal"
                slotProps={{
                  htmlInput: {
                    pattern: "[-A-Z0-9]*",
                  },
                }}
              />
              <Button
                disabled={makeRequest}
                variant="contained"
                sx={theme => ({ m: theme.spacing(3, 0, 2, 2) })}
                onClick={() => {
                  setMakeRequest(true);
                }}
              >
                Move
              </Button>
            </Box>
          </div>
        </Box>
      }
    />,
    <ErrorModal
      key="error"
      handleCloseErrorModal={handleCloseErrorModal}
      openErrorModal={openError}
      errorMessage={errorMessage}
    />,
  ];
};

BillingEventCapsComponent.propTypes = {
  requestFn: PropTypes.func.isRequired,
  stateErrorMessage: PropTypes.string.isRequired,
  resetFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  stateErrorMessage: state.billing.errorMessageEvn,
});

const mapDispatchToProps = dispatch => ({
  requestFn: async (fromDocumentNo, toDocumentNo) => {
    await dispatch(moveEVN(fromDocumentNo, toDocumentNo));
  },
  resetFn: () => dispatch(restEVNError()),
});

const BillingEventCaps = connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingEventCapsComponent);

export default BillingEventCaps;
